import React from "react";
import { useTranslation } from 'react-i18next';

const JudgeName = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation();
    return t("judge." + props.val);
}

const judgeNames = [<JudgeName val="BEST" />, <JudgeName val="FANTASTIC" />, <JudgeName val="VG" />, <JudgeName val="PG" />, <JudgeName val="DECENT" />, <JudgeName val="NG" />];

const judgeNamesFull = [<JudgeName val="NG" />, 
                        <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, <JudgeName val="DECENT" />, 
                        <JudgeName val="PG" />, <JudgeName val="PG" />, <JudgeName val="PG" />, <JudgeName val="PG" />, <JudgeName val="PG" />, <JudgeName val="PG" />, <JudgeName val="PG" />, <JudgeName val="PG" />, <JudgeName val="PG" />, <JudgeName val="PG" />, 
                        <JudgeName val="VG" />, <JudgeName val="VG" />, <JudgeName val="VG" />, <JudgeName val="VG" />, 
                        <JudgeName val="FANTASTIC" />, 
                        <JudgeName val="BEST" />];

export default JudgeName;

export {judgeNames, judgeNamesFull};